import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import { useHoliday } from '../../contexts/holiday';
import { useAuth } from '../global/Authentication/AuthProvider';
import ClickableTooltip from './ClickableTooltip';
import AccountControl from './AccountControl';
import UserAvatar from './UserAvatar';
import globalApi from '../../apis/swagup/global';
import { useProfileCore } from '../../hooks/globalQueries';
import { useBreakpointDown } from '../../hooks';

const useStyles = makeStyles({
  menuIcon: { color: '#4A4F54', width: 16 },
  menuContainer: {
    cursor: 'pointer',
    width: 72,
    height: 40,
    padding: 8,
    border: '1px solid #E5E7E8',
    borderRadius: 8,
    '&:hover': {
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.12), 0px 12px 24px 2px rgba(0, 0, 0, 0.06)'
    }
  }
});

const MenuDropdown = ({ profile, currentAccount, logout, login, handleAccountSwap, classes }) => {
  const isXs = useBreakpointDown('xs');

  const avatar = profile ? (
    <UserAvatar name={profile.first_name} nameForColorGeneration={currentAccount?.name} size={24} />
  ) : (
    <img src="/images/public/log-in.svg" alt="Log In" />
  );

  const title = <AccountControl profile={profile} onSwapAccount={handleAccountSwap} logout={logout} login={login} />;

  return (
    <ClickableTooltip title={title} placement="bottom-end" isAccountDropdown>
      <Grid
        container
        alignItems="center"
        justifyContent="space-around"
        className={!isXs ? classes.menuContainer : undefined}
      >
        {!isXs && <MenuIcon className={classes.menuIcon} />}
        {avatar}
      </Grid>
    </ClickableTooltip>
  );
};

const AccountProfile = ({ isDashboardHeader }) => {
  const classes = useStyles();
  const { logout } = useAuth();
  const { data: profile, isFetching, isError, refetch } = useProfileCore();
  const { currentAccount } = profile ?? {};

  useEffect(()=>{
    refetch()
  },[])
  
  const handleAccountSwap = async accountId => {
    await globalApi.setAccount(profile.id, { current_account: accountId });
    const newLocation = isDashboardHeader ? '/dashboard' : '/';
    window.location.assign(`${window.location.origin}${newLocation}`);
  };

  return (
    !isFetching &&
    !isError && (
      <MenuDropdown
        profile={profile}
        currentAccount={currentAccount}
        logout={logout}
        handleAccountSwap={handleAccountSwap}
        classes={classes}
      />
    )
  );
};

const LoggedIn = ({ isDashboardHeader }) => (
  <Grid container alignItems="center" justifyContent="flex-end">
    <AccountProfile isDashboardHeader={isDashboardHeader} />
  </Grid>
);

const LoggedOut = () => {
  const { login } = useAuth();
  const darkMode = useHoliday();
  const classes = useStyles({ darkMode });

  return (
    <Grid container alignItems="center" justifyContent="flex-end">
      <MenuDropdown login={login} classes={classes} />
    </Grid>
  );
};

export { AccountProfile, LoggedIn, LoggedOut };
